"use client";
import Header from "./components/landingPage/Header";
import "common/assets/css/landing-page.css";
import HeroSection from "./components/landingPage/HeroSection";
import Parntenrs from "./components/landingPage/Partners";
import RelationshipSection from "./components/landingPage/RelationshipSection";
import FeatureSection from "./components/landingPage/FeatureSection";
import ToolsSection from "./components/landingPage/ToolsSection";
import Constumers from "./components/landingPage/CustomersSection";
import { Box } from "@chakra-ui/react";
import Pricing from "./components/landingPage/Pricing";
import FAQ from "./components/landingPage/Faq";
import CallToAction from "./components/landingPage/CallToAction";
import Footer from "./components/landingPage/Footer";
import WhyChooseUs from "./components/landingPage/WhyChooseUs";
import PasswordManagementSection from "./components/landingPage/PasswordManagementSection";
import VideoSection from "./components/landingPage/VideoSection";
import PrivacyPolicy from "./privacyPolicy";

const LandingPage = () => {
  const handleNavigate = () => {
    window.location.hash = "#/auth/sign-in";
  };
  return (
    <>
      <Box className="landingPage">
        <Header handleNavigate={handleNavigate} />
        <HeroSection handleNavigate={handleNavigate} />
        <Parntenrs />
        <WhyChooseUs />
        <FeatureSection />
        <PasswordManagementSection />
        <VideoSection />
        {/* <RelationshipSection /> */}
        {/* <ToolsSection /> */}
        <Pricing />
        <Constumers />
        <FAQ />
        <CallToAction />
        <Footer />
      </Box>
    </>
  );
};

export default LandingPage;
